var _defs, _circle, _text, _text2, _clipPath;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoOnly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "44mm",
    height: "44mm",
    viewBox: "0 0 4400 4400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n   \n    @font-face { font-family:\"Times New Roman\";font-variant:normal;font-style:normal;font-weight:normal;src:url(\"#FontID0\") format(svg)}\n    .str0 {stroke:black;stroke-width:20}\n    .fil0 {fill:none}\n    .fil1 {fill:black}\n    .fnt0 {font-weight:normal;font-size:767.87px;font-family:'Times New Roman'}\n   \n  "))), /*#__PURE__*/React.createElement("g", {
    id: "rescale_container"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "fil0 str0",
    cx: 2200,
    cy: 2200,
    r: 2050,
    id: "plain_border"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo_container"
  }, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 1141,
    y: 2018,
    className: "fil1 fnt0"
  }, "LOGO")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 1205,
    y: 2868,
    className: "fil1 fnt0"
  }, "HERE")), /*#__PURE__*/React.createElement("rect", {
    className: "logo_position",
    x: 780,
    y: 780,
    width: 2840,
    height: 2840,
    style: {
      fill: "transparent"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "logo_cropped_position",
    x: 150,
    y: 150,
    width: 4100,
    height: 4100,
    style: {
      fill: "transparent"
    },
    clipPath: "url(#logoCrop)"
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "logoCrop"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 2050,
    cx: 2200,
    cy: 2200
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOnly);
export default __webpack_public_path__ + "static/media/logo-only.90b62d94cfe6a3c309537d28f412a819.svg";
export { ForwardRef as ReactComponent };